module.exports = __webpack_public_path__ + "img/logo-spotvnow-s.b0ed2f63.png";